import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Icon, Label, Wrapper } from './HeaderItem.styles';

type Props = {
    path: string;
    title: string;
    iconName: IconProp;
    color?: string;
    onItemClick?: () => void;
};

const HeaderItem: React.FC<Props> = (props) => {
    return (
        <Wrapper
            isClickable={props.onItemClick !== undefined}
            onClick={() => {
                if (props.onItemClick) props.onItemClick();
            }}
        >
            <Icon color={props.color}>
                <FontAwesomeIcon icon={props.iconName} />
            </Icon>
            <Label className="icon-text">{props.title}</Label>
        </Wrapper>
    );
};
export default HeaderItem;
